import { render, staticRenderFns } from "./ApplyClientsDialog.vue?vue&type=template&id=980b5264&scoped=true&"
import script from "./ApplyClientsDialog.vue?vue&type=script&lang=ts&"
export * from "./ApplyClientsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyClientsDialog.vue?vue&type=style&index=0&id=980b5264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980b5264",
  null
  
)

export default component.exports